import Style from "../Style.module.css"
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import * as UserService from "../../api/UserService";
import {Form, OverlayTrigger, Tooltip} from "react-bootstrap";
import cabinetStyle from "./MentorCabinet.module.css";
import AvailableStylesSelector from "../AvailableStylesSelector";
import moment from "moment/moment";
import {useTranslation} from "react-i18next";

function SetupIndividualGamePage(props) {
    const privateGamePrice = 0.5
    const singlePlayerGamePrice = 3
    const singlePlayerGamePriceNoVideo = 1
    const trialGamePrice = 0

    const [isManualDice, setIsManualDice] = useState(true)
    const [isAutoDice, setIsAutoDice] = useState(false)
    const [playerName, setPlayerName] = useState("")
    const [playerNameValid, setPlayerNameValid] = useState(false)
    const [gameName, setGamerName] = useState("")
    const [gameNameValid, setGameNameValid] = useState(false)
    const [trialGame, setTrialGame] = useState(false)
    const [personalGame, setPersonalGame] = useState(false)
    const [withVideo, setWithVideo] = useState(true)
    const [saveDisabled, setSaveDisabled] = useState(true)
    const [gamePrice, setGamePrice] = useState(trialGamePrice)
    const [selectedStyle, setSelectedStyle] = useState(0)
    const [selectedDeck, setSelectedDeckk] = useState()
    const inTrial = moment().isBefore(moment(props.freeTier))
    const { t } = useTranslation('translation', { keyPrefix: 'individualGameSetupPage' });

    const nav = useNavigate()

    function ResolveAutoDice() {
        setIsAutoDice(true)
        setIsManualDice(false)
    }

    function ResolveManualDice() {
        setIsManualDice(true)
        setIsAutoDice(false)
    }

    function ResolveTrialGame() {
        setTrialGame(!trialGame)
    }

    function ResolveWithVideo() {
        setWithVideo(!withVideo)
    }

    function ResolvePersonalGame() {
        setPersonalGame(!personalGame)
        ResolveAutoDice()
    }

    function ResolvePlayerName(event) {
        const n = event.target.value
        setPlayerName(n)
        if (!n.trim()) {
            setPlayerNameValid(false)
        } else {
            setPlayerNameValid(true)
        }
    }

    function ResolveGameFieldStyle(event) {
        setSelectedStyle(event.target.value)
    }

    function ResolveSelectedDeck(event) {
        setSelectedDeckk(event.target.value)
    }

    function ResolveDefaultDeck(deck) {
        setSelectedDeckk(deck)
    }

    function ResolveGameName(event) {
        const i = event.target.value
        setGamerName(i)
        if (!i.trim()) {
            setGameNameValid(false)
        } else {
            setGameNameValid(true)
        }
    }

    function saveNewGame() {
        setSaveDisabled(true)
        UserService.postCreateGame(
            playerName,
            isAutoDice,
            gameName,
            trialGame,
            withVideo,
            selectedStyle,
            personalGame,
            gamePrice * 100,
            selectedDeck.split("-")[0],
            selectedDeck.split("-")[1],
            () => {
                props.setSelectedGameType(personalGame ? "privateGames" : "individualGames")
                props.callBack()
            },
            () => nav("/mentor/cabinet")
        )
    }

    function resolvePrice() {
        if (inTrial) {
            return trialGamePrice
        } else if (personalGame) {
            return privateGamePrice
        } else if (!withVideo) {
            return singlePlayerGamePriceNoVideo
        } else {
            return singlePlayerGamePrice
        }
    }

    useEffect(() => {
        let price = resolvePrice()
        setGamePrice(price)
        if (props.currentBalance >= price && gameNameValid && playerNameValid) {
            setSaveDisabled(false)
        } else {
            setSaveDisabled(true)
        }

    }, [gamePrice, gameNameValid, playerNameValid, personalGame, withVideo]);

    const renderTrialGameTooltip = (props) => (
        <Tooltip className="trialGameTooltip" id="trial-game-tooltip" {...props}>
            <p>{t('trialGameTooltip1')}</p>
            <div>{t('trialGameTooltip2')}</div>
            <p>{t('trialGameTooltip3')}</p>
        </Tooltip>
    )

    const renderPersonalGameTooltip = (props) => (
        <Tooltip className="privateGameTooltip" id="trial-game-tooltip" {...props}>
            <p>{t('personalGameTooltip')}</p>
        </Tooltip>
    )

    return (
        <div>
            <div>
                <div className={`${cabinetStyle.commonTile} ${cabinetStyle.profilePage}`}>
                    <Form>
                        <Form.Group className={cabinetStyle.profileElement}>
                            <Form.Label className={Style.bodyBaseText}>{t('playerName')}</Form.Label>
                            <Form.Control
                                id={"player_name_id"}
                                style={playerNameValid ? {
                                    marginBottom: "24px",
                                } : {
                                    marginBottom: "24px", border: "0.5px solid red",
                                }}
                                as="input"
                                onChange={e => ResolvePlayerName(e)}
                            />
                            <Form.Label className={Style.bodyBaseText}>{t('gameName')}</Form.Label>
                            <Form.Control
                                id={"game_name_id"}
                                style={gameNameValid ? {
                                    marginBottom: "24px",
                                } : {
                                    marginBottom: "24px", border: "0.5px solid red",
                                }}
                                as="input"
                                onChange={e => ResolveGameName(e)}
                            />
                            <Form.Label className={Style.bodyBaseText}>{t('diceType')}</Form.Label>
                            <Form>
                                <Form.Check
                                    style={{
                                        marginBottom: "24px"
                                    }}
                                    checked={isAutoDice}
                                    type="radio"
                                    label={t('autoDice')}
                                    onChange={e => ResolveAutoDice(e)}
                                />
                                <Form.Check
                                    style={{
                                        marginBottom: "24px"
                                    }}
                                    checked={isManualDice}
                                    type="radio"
                                    label={t('manualDice')}
                                    onChange={e => personalGame ? () => {
                                    } : ResolveManualDice(e)}
                                />
                            </Form>
                            <Form.Label className={Style.bodyBaseText}>{t('personalGame')}</Form.Label>
                            <Form>
                                <OverlayTrigger placement="top-start" delay={{show: 150, hide: 250}}
                                                overlay={renderPersonalGameTooltip}>
                                    <Form.Check
                                        style={{
                                            marginBottom: "24px",
                                        }}
                                        checked={personalGame}
                                        id={"personal_game"}
                                        type="switch"
                                        onChange={e => ResolvePersonalGame()}
                                    />
                                </OverlayTrigger>
                            </Form>
                            <Form.Label className={Style.bodyBaseText}>{t('trialGame')}</Form.Label>
                            <Form>
                                <OverlayTrigger placement="top-start" delay={{show: 150, hide: 250}}
                                                overlay={renderTrialGameTooltip}>
                                    <Form.Check
                                        style={{
                                            marginBottom: "24px",
                                        }}
                                        checked={trialGame}
                                        id={"trial_game"}
                                        type="switch"
                                        onChange={e => ResolveTrialGame()}
                                    />
                                </OverlayTrigger>
                            </Form>
                            <Form.Label className={Style.bodyBaseText}>{t('video')}</Form.Label>
                            <div style={{display: "grid", gridTemplateColumns: "1fr 2fr 1fr"}}>
                                <Form>
                                    <Form.Check
                                        style={{
                                            marginBottom: "24px",
                                        }}
                                        checked={withVideo}
                                        id={"trial_game"}
                                        type="switch"
                                        onChange={e => ResolveWithVideo()}
                                    />
                                </Form>

                            </div>

                            <AvailableStylesSelector selectedStyle={selectedStyle}
                                                     selectedDeck={selectedDeck}
                                                     setSelectedStyle={ResolveGameFieldStyle}
                                                     setDefaultDeck={ResolveDefaultDeck}
                                                     setSelectedDeck={ResolveSelectedDeck}/>

                            <br/>
                        </Form.Group>
                    </Form>
                    <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <button className={`${cabinetStyle.confirmCreateNewGame} ${cabinetStyle.sideBarText}`}
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr 1fr",
                                    justifyContent: "center",
                                    gap: "6"
                                }}
                                id={"saveButton"}
                                onClick={saveNewGame}
                                disabled={saveDisabled}>
                            <div>{t('createButton')}</div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "flex-end"
                                }}
                            >{gamePrice}
                                <div className={cabinetStyle.coinSmall}/>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>


    )
}

export default SetupIndividualGamePage